<div class="grid flex header-gap">
  <div class="col-12 p-0">
    <div class="page-header mb-6 gap-0">
      <h1 class="orders">{{ 'Order.OurTests' | translate }}</h1>
      <div class="yellow-underline"></div>
    </div>
  </div>
  <div class="col-12 md:col-10 md:col-offset-1">
    @if (categoryListState(); as state) {
      @if (state.status === eActionStatus.Success && state.successResponse && state.successResponse.length) {
        <p-tabs class="new-order" [value]="selectedValue()">
          <p-tablist>
            @for (category of state.successResponse; track category; let i = $index) {
              @if (category.enabled) {
                <p-tab [value]="i" [style]="{width: 90 / state.successResponse.length + '%'}">
                  <div data-testid="veracityPart" class="veracity-part">
                    <h4 class="veracity-text">
                      {{ category.name }}
                    </h4>
                  </div>
                </p-tab>
              }
            }
          </p-tablist>
          <p-tabpanels>
            @for (category of state.successResponse; track category; let i = $index) {
              @if (category.enabled) {
                <p-tabpanel [value]="i" class="pt-0">
                  <div class="col-12 md:col-8 md:col-offset-2">
                    @for (product of category.products; track product; let l = $last) {
                      <div>
                        <p-button
                          variant="text"
                          styleClass="w-full h-auto inline-block hover:bg-black-alpha-10"
                          (onClick)="selectProduct(product)">
                          <span class="align-items-center inline-flex justify-content-between w-full mb-2">
                            <h4 class="">{{ product.name }}</h4>
                            <i class="pi pi-arrow-right bg-primary-50 text-primary border-round p-3"></i>
                          </span>
                          <span class="large-paragraph block text-justify text-base" [innerHTML]="product.description">
                          </span>
                        </p-button>
                        @if (!l) {
                          <p-divider />
                        }
                      </div>
                    }
                  </div>
                </p-tabpanel>
              } @else {
                <div class="p-2">
                  <p-message severity="info" [closable]="false">
                    <div class="content-box">
                      <span class="summary-txt">Info</span>
                      <span> {{ 'Order.CategoryNotActive' | translate }}</span>
                    </div>
                  </p-message>
                </div>
              }
            }
          </p-tabpanels>
        </p-tabs>
      }
      @if (
        (state.status === eActionStatus.Error || state.status === eActionStatus.Failure) &&
        (!state.successResponse || !state.successResponse.length)
      ) {
        <div class="p-2">
          <p-message severity="info" [closable]="false" icon="pi pi-info-circle">
            <div class="content-box">
              <span class="summary-txt">Info</span>
              <span>{{ 'Order.CategoryLoadingFailed' | translate }}</span>
            </div>
          </p-message>
        </div>
      }
      @if (state.status === eActionStatus.Initial || state.status === eActionStatus.Pending) {
        <div class="grid">
          <div class="flex flex-auto justify-content-center my-2">
            <ng-container
              *ngTemplateOutlet="
                loadingTemplate;
                context: {
                  config: {
                    count: 3,
                    width: '20vw',
                    height: '5rem',
                    inline: true,
                  },
                }
              " />
          </div>
          <div class="flex flex-auto justify-content-center my-2">
            <ng-container
              *ngTemplateOutlet="
                loadingTemplate;
                context: {
                  config: {
                    count: 5,
                    width: '50vw',
                    height: '5rem',
                    inline: false,
                  },
                }
              " />
          </div>
        </div>
      }
    }
  </div>
</div>

<ng-template #loadingTemplate let-config="config">
  <div [class.flex]="config.inline">
    @for (n of getNumberArray(config.count); track n) {
      <div
        class="p-2"
        [class.inline-flex]="config.inline"
        [class.w-full]="!config.inline"
        [class.flex]="!config.inline">
        <p-skeleton [width]="config.width" [height]="config.height" class="overflow-hidden" />
      </div>
    }
  </div>
</ng-template>
